import type { Session } from 'next-auth';
import { sanitizeDisplayName } from './string.helper';

/**
 * Resolves avatar source url
 *
 * The "User Attribute" session.user.picture is either hardcoded in keycloak for
 * the particular user or the identity provider's mapper defined in keycloak
 * will dynamically set it when the user logs in based on the user fields
 * provided by the identity provider.
 */
export const getAvatarSource = (session: Session): string | undefined => {
  return session?.user?.picture;
};

/**
 * Derives avatar props from a session: source URL, initials (first char
 * of display name), and alt text. ModGeneralAvatar derives its background
 * color from `alt`, so no explicit color index is needed.
 */
export const getSessionAvatarProps = (session: Session) => {
  const avatarSource = getAvatarSource(session);
  const displayName = session?.user?.fullName || session?.user?.userName;
  const avatarInitials = displayName
    ? sanitizeDisplayName(displayName).charAt(0)
    : undefined;
  const alt = sanitizeDisplayName(
    session?.user?.userName || session?.user?.fullName || 'user avatar'
  );
  return { avatarSource, avatarInitials, alt };
};
